module.exports = __webpack_public_path__ + "img/11-TAMARIN_INDE-min.e62ac44c.jpg";